import { Component } from '@angular/core';
import { AssetGrouping } from '@app/_models/assetGrouping';
import { AssetHistoryActionType } from '@app/_models/assetHistoryActionType';
import { AssetType } from '@app/_models/enums/assetType';
import { Asset, AssetTypeName } from '@app/_models/_DTOs/asset';
import { AssetHistoryActionName } from '@app/_models/_DTOs/assetHistory';
import { BaseDto } from '@app/_models/_DTOs/baseDto';
import { Employee } from '@app/_models/_DTOs/employee';
import { Location } from '@app/_models/_DTOs/location';
import { SelectionService } from '@app/_services/selection.service';

@Component({
    selector: 'app-selection',
    templateUrl: './selection.component.html',
    styleUrls: ['./selection.component.css']
  })
  export class SelectionComponent {
    listVisible = false;


    public assetHistoryActionType = AssetHistoryActionType;
    public assetTypes = AssetType;
  
    constructor(private selectionService: SelectionService
    ){

    }

    // toggleList(){
    //     this.listVisible = !this.listVisible;
    // }

    clearList(){
        this.selectionService.clearSelection();
        this.listVisible = false;
    }

    deselect(asset: Asset){
        this.selectionService.removeFromSelection(asset, true);
        if(this.selectionService.selectedAssets.length == 0){
            this.listVisible = false;
        }
    }

    public getActionTypeName(actionType: AssetHistoryActionType) {
        return AssetHistoryActionName.get(actionType).name;
    }

    public getAssetTypeName(assetType: AssetType) {
        return AssetTypeName.get(assetType);
    }

    public assetTypeKeys() {
        var keys = Object.keys(this.assetTypes);
        return keys.slice(keys.length / 2);
    }

}